import { IAppRootScopeService } from '@/app/app.definition';
import { JavaApiAdapterService } from '@/app/common/apiadapter/javaapi.service';
import { User } from '@/app/common/model/user';
import { IUserService } from '@/app/common/service/user.service';
import angular from 'angular';

export class CorruptVkResetController {
    showLoader: any;

    static $inject = ["ApiAdapterService", "UserService", "$rootScope"];

    constructor(private $_api: JavaApiAdapterService,
        private $_user: IUserService,
        private $rootScope: IAppRootScopeService) {
        $rootScope.mainShowLoader = false;
        $rootScope.rootShowLoader = false;
    }
    sendResetEmail = () => {
        this.showLoader = true;
        const user = new User();
        user.id = this.$_user.getMyId();
        this.$_api.initBackupPasswordReset(user).then(
            (s) => {
                toastr.success("Email sent. Please check your inbox again.");
            }).finally(() => {
                this.showLoader = false;
            });
    }
}

angular.module('eCareVault.authentication')
    .controller('CorruptVkResetController', CorruptVkResetController);
